import React, { useState } from 'react';
import { Button, Input, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { CgClose } from 'react-icons/cg';
import { FiSliders } from 'react-icons/fi';
import { MdOutlineHistory } from 'react-icons/md';
import { AiOutlineSearch } from 'react-icons/ai';
import update from 'immutability-helper';
import clsx from 'clsx';
import List from '../List';
import Recipe from '../Recipe';
import { addNewSearchTerm, removeSearchTerm } from '../../redux/actions/searchTerms';
import { setRecentSearchTerms } from '../../services/localStorageHandler';
import { useStyles } from './styles';
import './styles.sass';

const Search = ({ showRecipe, setShowRecipe }) => {
    const [keyword, setKeyword] = useState('');
    const [isSearched, setIsSearched] = useState(false);
    const recipes = useSelector(state => state.recipes);
    const searchTerms = useSelector(state => state.searchTerms);
    const dispatch = useDispatch();
    const classes = useStyles();
    let result = recipes.filter((recipe) => recipe.name.includes(keyword));
    let clicks = [];
    let timeout;

    const handleTermSelect = (term) => {
        setKeyword(term);
        setIsSearched(true);
    }

    const handleRemoveTerm = (index) => {
        const updatedSearchTerms = update(searchTerms, { $splice: [[index, 1]] });
        setRecentSearchTerms(JSON.stringify(updatedSearchTerms)); // Update localStorage
        dispatch(removeSearchTerm(index)); // Update store
    }

    const onTermClicked = (term, index, event) => {
        event.preventDefault();
        clicks.push(new Date().getTime());
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            if (clicks.length > 1 && clicks[clicks.length - 1] - clicks[clicks.length - 2] < 250) {
                handleRemoveTerm(index);
            } else {
                handleTermSelect(term);
            }
        }, 250);
    }

    const handleSearch = (e) => {
        e.preventDefault();
        setIsSearched(true);
        // Check if keyword exists in search terms array
        if (!searchTerms.includes(keyword.trim())) {
            const updatedSearchTerms = update(searchTerms, { $push: [keyword] });
            setRecentSearchTerms(JSON.stringify(updatedSearchTerms)); // Update localStorage
            dispatch(addNewSearchTerm(keyword)); // Update store
        }
    }

    const onResetSearch = () => {
        setIsSearched(false);
        setKeyword('');
    }

    return !showRecipe ? (
        <div className="search-container">
            <form onSubmit={handleSearch}>
                <div className="input-wrapper">
                    <AiOutlineSearch style={{ fontSize: 20 }} />
                    <Input
                        value={keyword}
                        onChange={(e) => {
                            setKeyword(e.target.value);
                            if (isSearched)
                                setIsSearched(false);
                        }}
                        placeholder={`חיפוש מתכון מבין ${recipes.length} מתכונים...`}
                        disableUnderline
                        required
                        autoFocus
                        className={classes.input}
                    />
                    {keyword.length > 0 &&
                        <Button
                            disableRipple
                            onClick={onResetSearch}
                            className={classes.button}
                        >
                            <CgClose />
                        </Button>
                    }
                </div>
            </form>
            {isSearched ?
                result.length > 0 ?
                    <div className="results">
                        <Typography className={clsx(classes.text, classes.message)} gutterBottom>
                            {result.length > 1 ?
                                `${result.length} מתכונים נמצאו`
                                :
                                `נמצא מתכון אחד`
                            }
                        </Typography>
                        <List
                            recipes={result}
                            setShowRecipe={setShowRecipe}
                        />
                    </div>
                    :
                    <div className="message">
                        <FiSliders className="icon" />
                        <Typography variant='h5' className={clsx(classes.text, classes.center)} gutterBottom>לא נמצאו מתכונים</Typography>
                        <Typography className={clsx(classes.text, classes.center)}>
                            {`לא נמצאה התאמה לערך "${keyword}".  נסה לחפש שוב.`}
                        </Typography>
                    </div>
                :
                <div>
                    {searchTerms.length > 0 && (
                        <div className="search-terms">
                            <Typography variant='h6' className={classes.text}>חיפושים אחרונים</Typography>
                            {searchTerms.map((term, index) => {
                                return (
                                    <div
                                        key={index}
                                        className="search-box"
                                        onClick={(e) => onTermClicked(term, index, e)}
                                    >
                                        <div className="search-box-icon">
                                            <MdOutlineHistory className="icon" />
                                        </div>
                                        <Typography className={classes.text}>{term}</Typography>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </div>
            }
        </div>
    ) : (
        <Recipe setShowRecipe={setShowRecipe} />
    )
}

export default Search;